import {
	PHARMACY_FILE_MANAGER_GET_FILES_REQUEST,
	PHARMACY_FILE_MANAGER_GET_FILES_SUCCESS,
	PHARMACY_FILE_MANAGER_GET_FILES_FAILURE,
} from "../../../constants";

const initialState = {
	data: null,
	loading: false,
	error: null,
};

const pharmacyFileManagerGetFiles = (state = initialState, action) => {
	switch (action.type) {
		case PHARMACY_FILE_MANAGER_GET_FILES_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case PHARMACY_FILE_MANAGER_GET_FILES_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
			};
		case PHARMACY_FILE_MANAGER_GET_FILES_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null,
			};
		default:
			return state;
	}
};

export default pharmacyFileManagerGetFiles;
